import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import PageLayout from '@/components/PageLayout'
import Header from '@/components/Header'
import Back from '@/components/Back'
import CustomTextInput from '@/components/CustomTextInput'
import CustomButton from '@/components/CustomButton'
import { Toast } from 'react-vant'
import { useSendCode } from '@/hooks/useSendCode'

export default React.memo(function BindPhone() {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const [phone, setPhone] = useState('')
    const { sendCode, sendCodeLoading } = useSendCode()

    // 验证手机号格式（6-15位数字）
    const isValidPhone = (phone: string) => {
        const phoneRegex = /^\d{6,15}$/
        return phoneRegex.test(phone)
    }

    // 手机号输入处理（只允许数字）
    const handlePhoneChange = (value: string) => {
        const numericValue = value.replace(/[^\d]/g, '')
        setPhone(numericValue)
    }

    // 发送验证码
    const handleSendCode = async () => {
        if (!phone.trim()) {
            Toast.fail(t('请输入手机号'))
            return
        }

        if (!isValidPhone(phone)) {
            Toast.fail(t('请输入有效的手机号6至15位数字'))
            return
        }

        try {
            await sendCode({
                account: phone,
                scene: 'bind_phone',
                callBack: () => {
                    // 跳转到验证码验证页面
                    navigate('/safety/bind-phone/verify-code', {
                        state: { phone }
                    })
                }
            })
        } catch (error) {
            console.error('发送验证码失败:', error)
        }

    }

    return (
        <PageLayout tabbarPage={false}>
            <Header
                leftChildren={<Back />}
                centerChildren={<div className="text-3.75 font-medium text-black">{t('绑定手机号')}</div>}
            />
            <div className='px-6 py-6'>
                {/* 手机号输入 */}
                <div className="mb-6">
                    <div className="text-3.5 text-[#1A1A1A] mb-3">{t('手机号')}</div>
                    <CustomTextInput
                        value={phone}
                        onChangeText={handlePhoneChange}
                        placeholder={t('请输入手机号')}
                        inputMode='tel'
                    />
                </div>

                {/* 发送验证码按钮 */}
                <CustomButton
                    onClick={handleSendCode}
                    loading={sendCodeLoading}
                    disabled={!phone.trim() || sendCodeLoading}
                >
                    {t('发送验证码')}
                </CustomButton>
            </div>
        </PageLayout>
    )
})